import { gql } from '@parkchirp/api-client';

export const GET_PUT_SIGNED_URL = gql`
    query getPutSignedUrl(
        $bucket: String!,
        $s3Key: String!
    ) {
        getPutSignedUrl (
            bucket: $bucket,
            s3Key: $s3Key
        ) {
            url
        }
    }
`;

export const GET_DELETE_SIGNED_URL = gql`
    query getDeleteSignedUrl(
        $bucket: String!,
        $s3Key: String!
    ) {
        getDeleteSignedUrl (
            bucket: $bucket,
            s3Key: $s3Key
        ) {
            url
        }
    }
`;

export const GET_PRESIGNED_URL = gql`
    query getPresignedUrl(
        $bucket: String!,
        $s3Key: String!
        $addEnv: Boolean
    ) {
        getPresignedUrl (
            bucket: $bucket,
            s3Key: $s3Key,
            addEnv: $addEnv,
        ) {
            presignedUrl
        }
    }
`;
